import { render, staticRenderFns } from "./selectComponent.vue?vue&type=template&id=a8564304&"
import script from "./selectComponent.vue?vue&type=script&lang=js&"
export * from "./selectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports